import logo from "@/assets/logo.webp";
import baer from "@/assets/baer.jpeg";
import heroTeddy from "@/assets/hero_teddy.jpeg";
import jciLogo from "@/assets/jci-logo.png";
import swissKids from "@/assets/swiss_kids.jpeg";
import teddy from "@/assets/teddy.png";
import einzahlung from "@/assets/einzahlung.png";
import qrCode from "@/assets/qr_code.png";

export const IMAGES = {
  logo,
  jciLogo,
  baer,
  heroTeddy,
  swissKids,
  teddy,
  einzahlung,
  qrCode,
  // Emotional storytelling imagery
  childBear: "https://images.unsplash.com/photo-1578496781197-b85385c7f0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  nurseChild: "https://images.unsplash.com/photo-1712239009709-3d3562a15b72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  childBed: "https://images.unsplash.com/photo-1578496781379-7dcfb995293d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  familyHands: "https://images.unsplash.com/photo-1562494794-d59c886e2bf2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  joy: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

// Offizieller Spendenlink (Spheriq/Spendenschweiz) — bei Bedarf anpassbar
export const DONATION_URL = "https://app.spendenschweiz.ch/donation-standalone/xtSDj4ZjBd?mode=standalone";

export const EVENT = {
  kicker: "Benefizanlass JCI Zürich Flughafenregion",
  date: "24. September 2026",
  time: "17.30 Uhr",
  location: "Altes Feuerwehrgebäude",
  city: "8403 Wallisellen",
  host: "JCI FRZ Social Impact",
  beneficiary: "Stiftung Chance für das kritisch kranke Kind",
};

export const BANK = [
  ["Kontoinhaber", "Junior Chamber International Flughafenregion Zürich, 8180 Bülach"],
  ["Finanzinstitut", "Zürcher Kantonalbank, Postfach, 8010 Zürich"],
  ["Bankclearing-Nr. (BC-Nr.)", "700"],
  ["IBAN", "CH12 0070 0110 0067 0261 0"],
  ["Bankkonto-Nr.", "1100-6702.610"],
  ["SWIFT-Adr. (BIC)", "ZKBKCHZZ80A"],
  ["Vermerk / Bemerkung", "JCI Social Impact"],
];

export const PROGRAM = [
  { time: "17:30", title: "Eintreffen", icon: "DoorOpen" },
  { time: "17:45", title: "Begrüssung", icon: "Users" },
  { time: "18:00", title: "Referat Stiftung Chance", icon: "Presentation" },
  { time: "19:00", title: "Resumée", icon: "ClipboardCheck" },
  { time: "19:30", title: "Apéro Riche", icon: "Wine" },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Kritisch kranke Kinder unterstützen",
    text: "Kritisch kranke Kinder benötigen nicht nur medizinische Spitzenversorgung, sondern auch besondere Unterstützung, Fürsorge und Hoffnung – jeden einzelnen Tag.",
    image: "childBear",
  },
  {
    no: "02",
    title: "Innovative Projekte am Kinderspital Zürich",
    text: "Die Stiftung Chance ermöglicht Angebote, die über die reguläre medizinische Versorgung hinausgehen und Frühgeborenen wie schwer kranken Kindern neue Perspektiven schenken.",
    image: "nurseChild",
  },
  {
    no: "03",
    title: "Betreuung & Lebensqualität verbessern",
    text: "Betreuung und Lebensqualität der betroffenen Kinder stehen im Zentrum – damit auch in schwierigen Zeiten Raum für Kindheit, Nähe und Geborgenheit bleibt.",
    image: "childBed",
  },
  {
    no: "04",
    title: "Familien Hoffnung schenken",
    text: "Familien in belastenden Situationen erhalten Entlastung und Hoffnung. Der Reinerlös des Anlasses kommt vollumfänglich der Stiftung Chance zugute.",
    image: "familyHands",
  },
];
